<script lang="ts">
	import IntersectionObserver from 'components/IntersectionObserver/IntersectionObserver.svelte';

	export let redditUrl = '';
	export let twitterUrl = '';
	export let dark;
	export let id;
</script>

<section class="social-posts-wrapper" class:dark>
	<IntersectionObserver let:intersecting once={true} top={200}>
		{#if intersecting}
			{#if redditUrl}
				{#await import('./RedditNetwork.svelte') then c}
					<svelte:component this={c.default} {redditUrl} {dark} {id} />
				{/await}
			{/if}
			{#if twitterUrl}
				{#await import('./TwitterNetwork.svelte') then c}
					<svelte:component this={c.default} {twitterUrl} {dark} />
				{/await}
			{/if}
		{/if}
	</IntersectionObserver>
</section>

<style lang="scss">
	@import 'socialNetworks';
</style>
